import axios from 'axios';

const axiosConfig = axios.create({
    baseURL: 'https://data-col-bk.bfgny.com/',
});

export default axiosConfig;
